import React from "react";
import styles from "./DietTypeFilter.module.css";

export type DietType = "vegan" | "glutenfrei" | "vegetarisch";

interface DietTypeFilterProps {
  selectedDietTypes: DietType[];
  disabledDietTypes?: DietType[];
  onDietTypesChange: (dietTypes: DietType[]) => void;
}

const DietTypeFilter: React.FC<DietTypeFilterProps> = ({
  selectedDietTypes,
  disabledDietTypes = [],
  onDietTypesChange,
}) => {
  const dietTypeOptions: { value: DietType; label: string }[] = [
    { value: "vegan", label: "Vegan" },
    { value: "glutenfrei", label: "Gluten Free" },
    { value: "vegetarisch", label: "Vegetarian" },
  ];

  const handleDietTypeToggle = (dietType: DietType) => {
    if (disabledDietTypes.includes(dietType)) return;

    if (selectedDietTypes.includes(dietType)) {
      // Remove diet type
      onDietTypesChange(selectedDietTypes.filter((type) => type !== dietType));
    } else {
      // Add diet type (max 3)
      if (selectedDietTypes.length < 3) {
        onDietTypesChange([...selectedDietTypes, dietType]);
      }
    }
  };

  return (
    <div className={styles.dietTypeFilter}>
      <div className={styles.filterTags}>
        {dietTypeOptions.map((option) => (
          <button
            key={option.value}
            className={`${styles.dietTag} ${
              selectedDietTypes.includes(option.value) ? styles.selected : ""
            } ${disabledDietTypes.includes(option.value) ? styles.disabled : ""}`}
            onClick={() => handleDietTypeToggle(option.value)}
            disabled={
              (!selectedDietTypes.includes(option.value) &&
              selectedDietTypes.length >= 3) ||
              disabledDietTypes.includes(option.value)
            }
          >
            {option.label}
          </button>
        ))}
      </div>
    </div>
  );
};

export default DietTypeFilter;
